import { useState } from "react";
import { useTranslation } from "react-i18next";
import { useDeleteModal } from "../../common/hooks/useDeleteModal";
import { AppSidebar } from "../../common/Sidebar";
import { CopyObjectButton } from "../../common/Sidebar/Components/SidebarButtons/CopyObjectButton";
import { CreateFolderButton } from "../../common/Sidebar/Components/SidebarButtons/CreateFolderButton";
import { ClassifierFolderNameChange } from "../../features/Classification/ClassifierFolderNameChange";
import { deleteClassifierAction } from "../../features/Classification/redux/actions/actions";
import { TransferClassifierModal } from "../../features/Classification/TransferClassifierModal";
import { AppDeleteDialog } from "../../shared/components/AppDialog/AppDeleteDialog";
import { useClassifiersPage } from "./hooks/use-classifiers-page";
import { useAppModals } from "../../app/state/modalSlice/hook/use-app-modals";
import { ObjectManagerModal } from "../../common/Components/Modals/components/ObjectManagerModal";
import { SafeOutlet } from "../../common/Protectors/SafeOutlet";
import styles from "./styles.module.css";

export const ClassificationPage = () => {
  const {
    deleteInfo,
    isDeleteModalOpen,
    handleDelete,
    openDeleteModal,
    closeDeleteModal,
  } = useDeleteModal(deleteClassifierAction);
  const {
    selectedClassifier,
    isClassifierLoading,
    classifiersSidebarItems,
    addClassifier,
    addFolder,
    copyObject,
    handleSelectClassifier,
  } = useClassifiersPage();
  const { t } = useTranslation();
  const [open, setOpen] = useState(false);
  const { handleCloseModal, handleOpenModal } = useAppModals();
  const [modalNameChangeOpen, setModalNameChangeOpen] = useState(false);
  const [selectedFolderId, setSelectedFolderId] = useState<string | null>(null);
  const [selectedId, setSelectedId] = useState<string | null>(null);

  const handleModalOpen = (id: string) => {
    setSelectedId(id);
    setOpen(true);
  };
  const handleModalClose = () => {
    setOpen(false);
  };

  const handleOpenNameChangeModal = (id: string) => {
    setSelectedFolderId(id);
    setModalNameChangeOpen(true);
  };

  const handleCloseNameChangeModal = () => {
    setModalNameChangeOpen(false);
  };

  return (
    <div className={styles["page-layout"]}>
      <AppSidebar
        menuItems={classifiersSidebarItems}
        defaultName={t("classification.default_name")}
        selectedId={selectedClassifier?.id}
        onSelect={handleSelectClassifier}
        onAdd={addClassifier}
        onDelete={(id, name) => openDeleteModal(id, name)}
        onOpenModal={(id) => handleModalOpen(id)}
        onOpenModalNameChange={(id) => handleOpenNameChangeModal(id)}
        handleCopyObject={copyObject}
        service={"classify"}
        isLoading={isClassifierLoading}
        isTransfer
        headerAdditionalContent={
          <CreateFolderButton
            handleCreateFolder={() =>
              handleOpenModal("object_manager", null, "create_folder")
            }
          />
        }
        footerAdditionalContent={
          <CopyObjectButton handleCopyObject={copyObject} />
        }
      />
      {selectedClassifier && <SafeOutlet />}
      <AppDeleteDialog
        dialogOpen={isDeleteModalOpen}
        deletingInfo={deleteInfo}
        handleDialogClose={closeDeleteModal}
        onDelete={handleDelete}
      />
      <TransferClassifierModal
        open={open}
        childId={selectedId as string}
        closeModal={handleModalClose}
      />
      <ClassifierFolderNameChange
        open={modalNameChangeOpen}
        childId={selectedFolderId as string}
        closeModal={handleCloseNameChangeModal}
      />
      <ObjectManagerModal
        service={"classify"}
        closeModal={handleCloseModal}
        defaultName={t("common.default_folder_name")}
        addFolder={addFolder}
      />
    </div>
  );
};
